var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videsCss",staticStyle:{"padding":"0 10px","background-color":"black"}},[_c('video',{ref:"videoElement",attrs:{"controls":"","autoplay":"","muted":"","width":"100%","height":"400px"},domProps:{"muted":true}})])}
var staticRenderFns = []

export { render, staticRenderFns }